const types = {
  actor: 'threat-actors',
  campaign: 'campaigns',
  malware: 'malware',
}

export function attackPatternAdapter(data, { type, ids = [] }) {
  const patterns = {}
  const { [types[type]]: items = [], 'attack-patterns': attackPatternsDict = {} } = data
  for (const item of items) {
    const { id: itemId, 'attack-patterns': itemPatterns, name: actorName } = item
    if (ids.indexOf(itemId) === -1 || !itemPatterns || itemPatterns === 'redacted') {
      continue
    }

    for (const [attackName, attacks] of Object.entries(itemPatterns)) {
      const patternBucket = patterns[attackName] || (patterns[attackName] = {})

      for (const pattern of Object.values(attacks)) {
        const { id, sub_techniques: subTechniques = [] } = pattern
        const patternDetails = attackPatternsDict[id]
        const {
          attack_pattern_identifier: identifier,
          name: patternName,
          description,
        } = patternDetails

        const subTechniqueList = []
        for (const subTechnique of subTechniques) {
          const { id: subId, attribution_scope: subScope } = subTechnique
          const subPatternDetails = attackPatternsDict[subId]
          if (subPatternDetails) {
            const {
              attack_pattern_identifier: subIdentifier,
              name: techniqueName,
              description: subDescription,
              x_mitre_is_subtechnique: isSubTechnique,
            } = subPatternDetails

            let subPatternBucket = patternBucket[subIdentifier]
            if (!subPatternBucket) {
              subPatternBucket = patternBucket[subIdentifier] = {
                identifier: subIdentifier,
                name: techniqueName,
                parent: patternName,
                associations: [],
                associationsIDs: [],
                associationsNames: [],
                description: subDescription,
                attribution_scope: subScope,
                isSubTechnique
              }
            }
            subPatternBucket.associations.push([itemId, actorName])
            subPatternBucket.associationsIDs.push(itemId)
            subPatternBucket.associationsNames.push(actorName)
          }
          subTechniqueList.push(subPatternDetails)
        }
        patternBucket[identifier] || (patternBucket[identifier] = {
          identifier,
          name: patternName,
          associations: [],
          associationsIDs: [],
          associationsNames: [],
          parent: null,
          description,
          attribution_scope: pattern.attribution_scope,
          subTechniqueList
        })

        const { associations, associationsIDs, associationsNames } = patternBucket[identifier]
        const map = new Map(associations)
        if (!map.has(itemId)) {
          associations.push([itemId, actorName])
          associationsIDs.push(itemId)
          associationsNames.push(actorName)
        }
      }
    }
  }

  for (const [attack, patternObj] of Object.entries(patterns)) {
    patterns[attack] = Object.values(patternObj)
  }
  return patterns
}
